import React, { useEffect, useState } from 'react';
import { CalculatorServices } from '../../../services';
import './style.css';
import { Layout, Input, Button, message } from 'antd';
const { Content } = Layout;

function parsePercent(value) {
  if (value === null || value === undefined || value === '') return null;
  const normalized = String(value).trim().replace(/\s/g, '').replace(',', '.');
  const number = Number(normalized);
  if (!Number.isFinite(number) || number < 0) return null;
  return number;
}

function formatPercent(rate) {
  const percent = Number(rate) * 100;
  if (!Number.isFinite(percent) || percent <= 0) return 0;
  return Math.round(percent * 100) / 100;
}

function CalculatorSettings() {
  const [taxaAdministracao, setTaxaAdministracao] = useState(0);
  const [taxaReferencia, setTaxaReferencia] = useState(0);
  const [saving, setSaving] = useState(false);

  async function fetchCalculatorParams() {
    const response = await CalculatorServices.fetchParams();
    setTaxaAdministracao(formatPercent(response.data.taxaAdministracao));
    setTaxaReferencia(formatPercent(response.data.taxaReferencia));
  }

  useEffect(() => {
    fetchCalculatorParams().catch(() => {
      message.error('Não foi possível carregar as taxas da calculadora.');
    });
  }, []);

  async function handleUpdateParams() {
    const administracao = parsePercent(taxaAdministracao);
    const referencia = parsePercent(taxaReferencia);

    if (administracao === null || referencia === null) {
      message.error('Informe as duas taxas com número. Ex.: 1,5 ou 1.5');
      return;
    }

    setSaving(true);
    try {
      const response = await CalculatorServices.updateParams({
        taxaAdministracao: Number((administracao / 100).toFixed(6)),
        taxaReferencia: Number((referencia / 100).toFixed(6)),
      });
      if (response?.data?.updated === false) {
        message.error(response.data.message || 'Não foi possível atualizar as taxas.');
        return;
      }
      await fetchCalculatorParams();
      message.success('Taxas atualizadas com sucesso.');
    } catch (error) {
      message.error('Não foi possível atualizar as taxas. Tente entrar de novo se a sessão expirou.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <Content style={{ margin: '24px 16px 0' }}>
      <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
        Configurações da Calculadora

        <div style={{ marginTop: '40px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <div style={{ width: '48%' }}>
            <label>Taxa de Administração</label>
            <Input
              addonBefore="%"
              placeholder="Taxa de administração"
              size="large"
              value={taxaAdministracao}
              onChange={(e) => setTaxaAdministracao(e.target.value)}
            />
          </div>
          <div style={{ width: '48%' }}>
            <label>Taxa de Referência</label>
            <Input
              addonBefore="%"
              placeholder="Taxa de referência"
              size="large"
              value={taxaReferencia}
              onChange={(e) => setTaxaReferencia(e.target.value)}
            />
          </div>
        </div>
        <Button className="button-update-calculator" type="primary" loading={saving} onClick={handleUpdateParams}>
          Atualizar Valores
        </Button>
      </div>
    </Content>
  );
}

export default CalculatorSettings;
